import React, { useState } from 'react';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { isEqual, omit } from 'lodash';
import { isNullOrEmpty, translate } from '@cyberint/common-utils';
import { IconButton, Icons, OutlinedButton, SearchInput, Modal, ModalModes } from '@cyberint/dsc';
import { t } from '@cyberint/stateful-ui/i18n';
import { Filters } from '@cyberint/stateful-ui/victimology/VictimologyTable/components/FiltersContainer/components/Filters';
import {
  initialVictimologyFilters,
  victimologyFiltersState,
  victimologyTempFiltersState
} from '@cyberint/stateful-ui/victimology/VictimologyTable/store/atoms';
import * as S from './styled';

const MODAL_SIZE = { height: '300px', width: '780px' };

export const FiltersContainer = () => {
  const [filters, setFilters] = useAtom(victimologyFiltersState);
  const [tempFilters, setTempFilters] = useAtom(victimologyTempFiltersState);
  const resetTempFilters = useResetAtom(victimologyTempFiltersState);
  const [searchValue, setSearchValue] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);

  const isDirty = !isNullOrEmpty(searchValue) || !isEqual(filters, initialVictimologyFilters);
  const modalFilters = omit(tempFilters, 'search');
  const hasModalFilters = Object.values(modalFilters).some(value => value.length > 0);

  const clearFiltersHandler = () => {
    setFilters(initialVictimologyFilters);
    setTempFilters(initialVictimologyFilters);
    setSearchValue('');
  };

  const onOkHandler = () => {
    setFilters(tempFilters);
    setModalOpen(false);
  };
  const onCloseHandler = () => setModalOpen(false);
  const filtersClickHandler = () => setModalOpen(true);
  const clearHandler = () => resetTempFilters();
  const clearSearchHandler = () => {
    setSearchValue('');
    setFilters({ ...filters, search: '' });
  };
  const onChangeHandler = ({ target: { value } }) => setSearchValue(value);
  const onSearchHandler = () => setFilters({ ...filters, search: searchValue.trim() });

  return (
    <S.Container>
      <OutlinedButton disabled={!isDirty} onClick={clearFiltersHandler} testId="button-clear_filters-victimology">
        {t('victimology.filters.clear_filters')}
      </OutlinedButton>
      <S.FilterSearchContainer>
        <IconButton icon={Icons.FiltersBare} onClick={filtersClickHandler} iconSize={18} />
        <SearchInput
          onClear={clearSearchHandler}
          onChange={onChangeHandler}
          onSearch={onSearchHandler}
          value={searchValue}
          width={275}
          placeholder={translate('common.search')}
          testId="input-search-victimology"
        />
      </S.FilterSearchContainer>
      <Modal
        mode={ModalModes.LIGHT}
        okText={t('victimology.filters.apply')}
        title={t('victimology.filters.title')}
        isOpen={isModalOpen}
        size={MODAL_SIZE}
        content={<Filters />}
        onOk={onOkHandler}
        onClose={onCloseHandler}
        additionalControls={
          <OutlinedButton disabled={!hasModalFilters} onClick={clearHandler}>
            {t('victimology.filters.clear_all')}
          </OutlinedButton>
        }
      />
    </S.Container>
  );
};
